document.addEventListener('DOMContentLoaded', function () {
  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderRef = this.querySelector('[data-slider]');
      this.prevRef = this.querySelector('[data-prev]');
      this.nextRef = this.querySelector('[data-next]');
      this.initSlider = this.initSlider.bind(this);
    }

    connectedCallback() {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        this.initSlider();
      } else {
        const checkInterval = setInterval(() => {
          if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
            clearInterval(checkInterval);
            this.initSlider();
          }
        }, 100);
      }
    }

    initSlider() {
      const $slider = $(this.sliderRef);
      if (!$slider.length) return;

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      $slider.slick({
        slidesToShow: 1.35,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        prevArrow: $(this.prevRef),
        nextArrow: $(this.nextRef),
        dots: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    disconnectedCallback() {
      const $slider = $(this.sliderRef);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  if (!customElements.get('cart-upsell-slider')) {
    customElements.define('cart-upsell-slider', CartUpsellSlider);
  }
});
